'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();

import { FormFeedback, Input, Label } from 'reactstrap';
import { filesize } from 'filesize';
import { Dictionaries } from '../../../i18n/i18n-config';
import { getI18nUtils } from '../../../i18n/i18n-utils';

interface FormikInputUploadProps {
  name: string;
  id?: string;
  required?: boolean;
  intlKey?: string;
  accept?: string;
  formik: any;
  className?: string;
  withoutLabel?: boolean;
  dictionary: Partial<Dictionaries>;
}

function FormikInputUpload(props: FormikInputUploadProps): JSX.Element {
  const { name, id, required, intlKey, formik, accept, className, withoutLabel, dictionary } = props;

  const { formatMessage } = getI18nUtils(dictionary);
  const onUpload = (uploadEvent: React.ChangeEvent<HTMLInputElement>) => {
    const file = uploadEvent.target.files?.[0];
    if (file) formik.setFieldValue(name, file);
  };

  const size = formik.values[name]?.size;

  const { touched, error } = formik.getFieldMeta(name);

  return (
    <div className={className || ''}>
      {!withoutLabel && (
        <Label for={name} className={required ? 'required' : ''}>
          {formatMessage({ id: intlKey || name })}
        </Label>
      )}

      <Input
        type="file"
        accept={accept}
        name={name}
        id={id || name}
        aria-label="Upload file"
        multiple={false}
        invalid={!!touched && error}
        onChange={onUpload}
      />
      {size && <small>{filesize(size)}</small>}
      {error && <FormFeedback>{formatMessage({ id: error })}</FormFeedback>}
    </div>
  );
}

export default FormikInputUpload;
